// /auth/link-sent — Figma frame 02 link-sent (33:915). Owner: screens-auth-a, US-081.
// Pre-login: deliberately no AppShell.
//
// `?email=` is optional and this route must render fine without it — reached
// directly (bookmark, reload, shared link) with no prior navigation state is
// an explicit acceptance criterion, not an edge case.

import { createRoute, useNavigate } from "@tanstack/react-router";
import { rootRoute } from "./__root";
import { LinkSentScreen } from "../screens/signin/LinkSentScreen";

type LinkSentSearch = { email?: string };

export const authLinkSentRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/auth/link-sent",
  validateSearch: (search: Record<string, unknown>): LinkSentSearch => ({
    email: typeof search.email === "string" ? search.email : undefined,
  }),
  component: AuthLinkSentRoute,
});

function AuthLinkSentRoute() {
  const { email } = authLinkSentRoute.useSearch();
  const navigate = useNavigate();
  return (
    <LinkSentScreen
      email={email}
      onUseDifferentEmail={() => navigate({ to: "/signin" })}
    />
  );
}
